import style from '../styles/components/maya-bg-page.module.scss'

const MayaBgPage = ({ children }) => {
  return (
    <div className={`${style.maya_bg_page}`}>
      <div className={style.bg_top}><img src="/images/bg/component-bg-1.png" className="full-w" alt="Section background start" /></div>
      { children }
      <div className={style.bg_bottom}><img src="/images/bg/component-bg-2.png" className="full-w" alt="Section background start" /></div>
    </div>
  );
}
export default MayaBgPage;